export const ONETRUST_DOMAIN = `otto.my.onetrust.eu`
export const ONETRUST_SCRIPT_BASE_URL = `https:/*                                     */
export const ONETRUST_SCRIPT_NAME = `otSDKStub.js`
export const ONETRUST_SCRIPT_BASE_PATH_SELF_HOSTED = 'onetrust-sdk'
export const ONETRUST_SCRIPT_PATH_PRODUCTION_INTERNALLY_HOSTED =
  'oneTrust_production/consent/'
export const ONETRUST_SCRIPT_PATH_TEST_INTERNALLY_HOSTED =
  'oneTrust_test/consent/'
